// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Details/Office/Search/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_Professionals_AddAction_New_Content_Details_Office_Search_Content($current_location_xid: String!) {
  app_admin_users_access(
    where: { xid: { _eq: $current_location_xid } }
    order_by: { organization_name: asc }
  ) {
    id
    organization_id
  }
}

`